import { render, staticRenderFns } from "./ShoppingOrderInfo.vue?vue&type=template&id=365f9b5b&"
import script from "./ShoppingOrderInfo.vue?vue&type=script&lang=js&"
export * from "./ShoppingOrderInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports